export default __webpack_public_path__ + "static/media/2.a2c08567.png";